import React, { useEffect, useState } from "react";
import {
  Toast,
  Userlogin,
  fetchDataFromApi,
  handleGetApiGF,
  handlePostApiGF,
} from "../Utils/general-function";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../Header";
import Loader from "../Utils/Loader";
import Search from "../Search";
// import RemainingPageTitle from "../Utils/RemainingPageTitle";
// import NoCars from "../Utils/NoCars";
// import { DatePicker } from "antd";
// import dayjs from "dayjs";
import SoldUnsoldListcm from "../Utils/SoldUnsoldListcm";

function SoldUnsoldThisMonth(props) {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const status = location.state.status;
  const [Carlist, setCarlist] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const navigate = useNavigate();
  // console.log("status", status);

  // const dateFormat = "DD/MM/YYYY";

  useEffect(() => {
    const fetchdata = async () => {
      if (!Userlogin()) {
        navigate("/Login");
        return;
      }
      if (!status) {
        navigate("/");
        return;
      }
      try {
        const cardata = await fetchDataFromApi(
          "/api/Carmaster/DealermonthlyBoughtorSoldcarlist?carstatus=" + status
        );

        if (
          cardata.Message === "Authorization has been denied for this request."
        ) {
          localStorage.clear();
          navigate("/Login");
          return;
        }
        // console.log("cardata", cardata);

        setCarlist(cardata.Data || []);
        setOriginalList(cardata.Data || []);
        setLoading(false);
        // console.log("cardata", cardata);
      } catch (error) {
        console.log("Exception found", error);
        setLoading(false);
      }
    };

    fetchdata();
  }, [navigate, status]);

  const handleCallback = (childData) => {
    setLoading(true);
    setCarlist(childData);
    setLoading(false);
  };

  return (
    <div>
      <Header />
      <div className="page-space" style={{ marginBottom: "50px" }}>
        <Search dataFromParent={originalList} parentCallback={handleCallback} />
        {/* date picker only for status sold car*/}
        {loading ? <Loader /> : null}
        <SoldUnsoldListcm carList={Carlist} />
      </div>
    </div>
  );
}

export default SoldUnsoldThisMonth;
